import * as React from 'react';
import { IRegularInfrastructureData } from '../../../types/map';
import { hasFutureObjects } from '../../../utils/map';
import { toRegularInfrastructureItems } from '../helpers/mappers';

export const useFutureInfrastructure = (
  regularInfrastructureByYearRef: React.MutableRefObject<Map<number, IRegularInfrastructureData>>,
) => {
  return React.useMemo(
    () => {
      const infrastructureItems = toRegularInfrastructureItems(regularInfrastructureByYearRef.current);

      return hasFutureObjects(infrastructureItems);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [regularInfrastructureByYearRef, regularInfrastructureByYearRef.current],
  );
};
